
export class PurchaseReportModel {
  orderId: number;
  customerContact: string;
  creationTime: Date;
  count: Number;
  totalPrice: number;
  bulk: string;
  productName: string;
  details: string;
  bankTransaction: string;
  isBulk:boolean;
  activationCode:string;
  isUsed:boolean;
  showActivationCode:boolean=false;
  expirationDate: Date = null;
  usageCounter: Number;
  maxUsageCount: Number;
}
